import axios from 'axios'
import {
  E_SERVER_HTTP,
  E_NETWORK,
  SUPPORT_EMAIL_ADDR
} from '@/constants'

const endpoint = axios.create({
  baseURL: '/api/v1/',
  headers: {
    Accept: 'application/json'
  }
})

endpoint.interceptors.response.use((response) => {
  const res = response.data
  if (res.error) { // transform hidden server error
    const err = new Error(res.error.message)
    err.id = E_SERVER_HTTP
    err.code = res.error.code
    err.config = response.config
    err.response = response
    throw err
  } else {
    return res
  }
}, (error) => {
  let err
  if (error.response) { // error response from server
    err = new Error(`HTTP error: ${error.response.status}`)
    err.id = E_SERVER_HTTP
    err.code = error.response.status
    if (error.response.data?.error?.code === 403 && error.response.data?.error?.message?.toLowerCase() === 'invalid nonce') { // nonce expired
      err.key = 'errors.nonceExpired'
      err.values = { supportEmail: SUPPORT_EMAIL_ADDR }
    }
    if (error.response.data?.error?.code === 401 && error.response.data?.error?.message?.toLowerCase() === 'invalid code') { // invalid signature
      err.key = 'errors.codeInvalid'
    }
  } else if (error.request) { // no response received from server
    err = new Error('network error')
    err.id = E_NETWORK
  } else { // axios error setting the request
    err = new Error(error.message)
  }
  // carry the axios context onto the replacement error, so later interceptors
  // can tell which request failed (see the nonce refresh guard in main.js)
  err.config = error.config
  err.response = error.response
  throw err
})

endpoint.nonceHeader = (nonce) => ({ 'X-Api-Nonce': nonce })

endpoint.withNonce = (nonce, options = {}) => {
  if (!nonce) return options
  return { ...options, headers: { ...options.headers, ...endpoint.nonceHeader(nonce) } }
}

export default endpoint
